module.exports = __webpack_public_path__ + "static/media/newportfolio.37490241.jpg";